<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="vendors">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="vendors"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="companyName" caption="Company" width="200" [sortIndex]="0" sortOrder="asc"></dxi-column>
            <dxi-column dataField="contactName" width="150"></dxi-column>
            <dxi-column dataField="address1"></dxi-column>
            <dxi-column dataField="address2"></dxi-column>
            <dxi-column dataField="city"></dxi-column>
            <dxi-column dataField="state" width="80"></dxi-column>
            <dxi-column dataField="postalCode" caption="Zip" width="80"></dxi-column>
            <dxi-column dataField="phone"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>
            <dxi-column dataField="fax"></dxi-column>
            <dxi-column dataField="quickBooksId"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" caption="QB Export" width="100"></dxi-column>
            <dxi-column dataField="inactive" width="70"> </dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="vendor-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)">Open</button>
                <button class="btn btn-secondary ms-2" (click)="open()">New</button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button>
                <button
                    class="btn btn-danger btn-sm ms-4"
                    (click)="toggleInactive(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Toggle Inactive
                </button>
                <button class="btn btn-sm btn-warning ms-4" (click)="toggleShowAll()">{{ filter.showAll ? 'Hide Inactive' : 'Show All' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="vendors" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
